// extracted by mini-css-extract-plugin
module.exports = {"label":"TextInput_label__3kH2w","input":"TextInput_input__bxLF-"};